module.exports = __webpack_public_path__ + "static/pelumi-7949ee993465490bbff7f12927051434.png";